import { BiUpArrowAlt } from 'react-icons/bi';

const Table = ({ columns, data, sort, handleSortChange, renderActions }) => {
    return (
        <table className="table-fixed w-full border-collapse divide-y divide-custom_blue shadow-md rounded-lg">
            <thead>
                <tr className="bg-custom_blue text-white text-xs md:text-base font-montserrat">
                    {columns.map((col) => (
                        <th
                            key={col.key}
                            className={`p-2 ${col.className || ''}`}
                            style={col.style}
                        >
                            {col.sortable ? (
                                <button
                                    onClick={() => handleSortChange(col.key)}
                                    className="flex items-center justify-center w-full h-full"
                                >
                                    {sort === col.key ? (
                                        <div className='flex items-center'>
                                            {col.label} <BiUpArrowAlt className='mx-2 scale-150' />
                                        </div>
                                    ) : col.label}
                                </button>
                            ) : col.label}
                        </th>
                    ))}
                    <th className="w-24"></th>
                </tr>
            </thead>
            <tbody className="bg-white divide-y divide-slate-200">
                {data.map((item, index) => (
                    <tr key={index} className="text-center font-montserrat font-medium text-xs lg:text-base text-custom_gray_font hover:bg-slate-50 transition-colors">
                        {columns.map((col) => (
                            <td
                                key={col.key}
                                className={`p-2 ${col.className || ''}`}
                                style={col.style}
                            >
                                {col.render ? col.render(item) : item[col.key]}
                            </td>
                        ))}
                        
                        <td className="p-2">
                            {renderActions && renderActions(item)}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default Table;